import dayjs from 'dayjs';
import { Solar } from 'lunar-javascript';
// 核心转换函数：公历转农历（几月初几）
export const solarToLunar = (month, day, year = new Date().getFullYear()) => {
    try {
        // 1. 创建公历日期对象（默认使用当前年份）
        const solarDate = Solar.fromYmd(year, month, day);
        // 2. 转换为农历对象
        const lunarDate = solarDate.getLunar();
        // 3. 获取农历的月、日（带中文，如 "七月十五"）
        const lunarMonth = lunarDate.getMonthInChinese(); // 农历月（如"七月"）
        const lunarDay = lunarDate.getDayInChinese(); // 农历日（如"十五"）
        // 4. 组合结果（如果是闰月，会自动包含"闰"字，如"闰二月初三"）
        const lunarStr = `${lunarMonth}月${lunarDay}`;
        return lunarStr;
    }
    catch (error) {
        console.error('日期转换失败：', error);
        return null;
    }
};
const isInTimeRange = (target, start, end, unit = 'millisecond', includeBoundary = true) => {
    // 1. 转换为 dayjs 实例（确保统一格式）
    const targetDayjs = dayjs(target);
    const startDayjs = dayjs(start);
    const endDayjs = dayjs(end);
    // 2. 校验日期有效性
    if (!targetDayjs.isValid() || !startDayjs.isValid() || !endDayjs.isValid()) {
        console.error('无效的日期格式');
        return false;
    }
    // 3. 核心比较逻辑
    const isAfterStart = includeBoundary ? targetDayjs.isAfter(startDayjs, unit) || targetDayjs.isSame(startDayjs, unit) : targetDayjs.isAfter(startDayjs, unit);
    const isBeforeEnd = includeBoundary ? targetDayjs.isBefore(endDayjs, unit) || targetDayjs.isSame(endDayjs, unit) : targetDayjs.isBefore(endDayjs, unit);
    return isAfterStart && isBeforeEnd;
};
